import { useMemo } from "react";

/** The IANA zones the browser knows, for a time zone field's suggestions. */
export function useZones(): string[] {
  return useMemo(() => {
    try {
      return (Intl as unknown as { supportedValuesOf(k: string): string[] }).supportedValuesOf("timeZone");
    } catch {
      return [];
    }
  }, []);
}
